import _ from 'lodash'
import React from 'react'
import { Radio, Table } from 'semantic-ui-react'

import Slot from './slot'

const Day = (props) => {
    let classes = ''
    classes = `${classes} ${props.last ? 'last' : ''}`
    classes = `${classes} ${props.day.available ? '' : 'unavailable'}`
    return (
        <Table.Row className={classes}>
            <Table.Cell>
                <Table>
                    <Table.Body>
                        {
                            /* eslint-disable react/no-array-index-key */
                            _.flattenDeep(props.day.slots.map((slot, index) => {
                                const errors = props.errors[index] || []
                                const erroneous = !_.isEmpty(errors)
                                return [(
                                    <Table.Row key={`${props.prefix}slot${index}`}>
                                        <Table.Cell className='availability'>
                                            {
                                                index === 0 ? (
                                                    <Radio
                                                        toggle
                                                        checked={props.day.available}
                                                        onChange={(_e) => { props.onToggleAvailability() }}
                                                    />
                                                ) : ''
                                            }
                                        </Table.Cell>
                                        <Table.Cell className='day'>
                                            {index === 0 ? props.day.name : ''}
                                        </Table.Cell>
                                        <Table.Cell className='slots'>
                                            <Slot
                                                prefix={`${props.prefix}slot${index}`}
                                                start={slot.start}
                                                end={slot.end}
                                                first={index === 0}
                                                last={index === props.day.slots.length - 1}
                                                disabled={!props.day.available}
                                                erroneous={erroneous}
                                                onAdd={() => { props.onAddSlot() }}
                                                onRemove={() => { props.onRemoveSlot(index) }}
                                                onChange={(field, v) => { props.onChangeSlot(index, field, v) }}
                                            />
                                        </Table.Cell>
                                    </Table.Row>
                                )].concat(errors.map((error, index) => {
                                    return (
                                        <Table.Row key={`${props.prefix}-error${index}`}>
                                            <Table.Cell colSpan={3}>
                                                <div className='error-message'>{error}</div>
                                            </Table.Cell>
                                        </Table.Row>
                                    )
                                }))
                            }))
                            /* eslint-enable react/no-array-index-key */
                        }
                    </Table.Body>
                </Table>
            </Table.Cell>
        </Table.Row>
    )
}

export default Day



// WEBPACK FOOTER //
// ./src/components/availability/day.js